<template>
    <div style="height: 100%">
        <div id="tzgg-body" ref="tzggElement">
            <CCBlockFrame :header="header">
                <div style="padding: 14px 10px 10px 10px">
                    <el-input v-model="filterText" style="margin-bottom: 10px; width: 96%; margin-left: 2%" placeholder="请输入搜索关键字">
                        <el-button slot="append" icon="el-icon-search" @click="getAllData" />
                    </el-input>
                </div>
                <ul v-if="allDataList.length > 0" id="item-body" class="autoStyle">
                    <template class="link-message">
                        <li v-for="(item, index) in allDataList" :key="index" class="link-message" @click="onCellLink(item, index)">
                            <div class="item">
                                <!-- <div v-if="item.readed=='0'" class="title" style="font-weight:700;"><span style="display:flex;"><span style="display: block;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{ item.flSubject }}</span> <span style="line-height: 30px;"><svg-icon style="color: #9B9B9B;font-size: 20px;" class-name="newT" icon-class="newT" /></span></span></div> -->
                                <div class="title" style="color: #333333; display: flex">
                                    <span class="msg">{{ item.name }}</span>
                                    <span class="right">{{ item.creator }}</span>
                                </div>
                                <div class="bottom">
                                    <!-- <span style="text-align:left" class="name">{{ item.wfNodeNames }}</span> -->
                                    <span style="text-align: left" class="name">{{ item.curStatus | stutsTrans }}</span>
                                    <span class="time">{{ item.establishTime | dateTrans }}</span>
                                </div>
                            </div>
                        </li>
                    </template>
                </ul>
                <div v-else>
                    <div slot="empty" style="text-align: center; margin-top: 30px">
                        <img src="images/w-imgs/nomessage.png" style="max-width: 180px" />
                        <br />
                        <span v-text-lbl="'common.noData'" style="font-size: 15px; color: #dbdbdb">暂无数据</span>
                    </div>
                </div>
            </CCBlockFrame>
        </div>
        <Basicform v-if="showdia" :append-to-body="true" :title="formTitle" :win-width="moduleInfo.winWidth" :win-height="moduleInfo.winHeight" :toolbar-btns="busiformBtns" :on-basic-form-before-open="onBasicFormBeforeOpen" :on-basic-form-opened="onBasicFormOpened" :on-basic-form-before-submit="onBasicFormBeforeSubmit" :on-basic-form-submited="onBasicFormSubmited">
            <template #default="slotProps">
                <busi-form ref="formItem" :vo="slotProps.vo" :can-edit="slotProps.canEdit" :module-info="moduleInfo" />
            </template>
        </Basicform>
    </div>
</template>

<script>
const moment = require('moment')
const nowTime = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
import { mapGetters } from 'vuex'
export default {
    name: 'PatyBuildingActivities',
    components: {},
    filters: {
        stutsTrans(val) {
            if (!val) {
                return ''
            } else if (val == 1) {
                return '存续'
            } else {
                return '注销'
            }
        },
        dateTrans(date) {
            if (!date) return ''
            return window.moment(date).format('YYYY年MM月DD日')
        }
    },
    props: {
        title: { type: String, default: '公告' },
        appletData: {
            type: Object,
            default: function () {
                return {}
            }
        }
    },
    data() {
        return {
            // 全部数据列表
            allDataList: [],
            // 数据列表
            dataList: [],
            header: {
                title: '分公司信息',
                more: true,
                icon: this.appletData.icon,
                code: 'fsggl'
            },
            listdataConfig: {
                // orderBy: 'pushTime desc',
                pageNum: 1,
                pageSize: 10000,
                order: 'asc'

                // listpageViewUrl: 'djgl.inforContent.list_yfb.vue',
                // urlsearch: 'flFormName!:通知公告'
            },
            filterText: '',
            moduleInfo: {
                formTemplate: 'dcontent/busiformurl?vwtype=W&url=/zbgl/fgsgl/form.html',
                winWidth: 1000,
                delUrl: 'zbgl/fgsgl/delete',
                addNewUrl: 'zbgl/fgsgl/addNew',
                insertUrl: 'zbgl/fgsgl/insert',
                moduleCode: 'fgsgl',
                listAdvSearchExpandPanel: 0,
                winHeight: 600,
                updateUrl: 'zbgl/fgsgl/update',
                listDataUrl: 'zbgl/fgsgl/listdata',
                getByIdUrl: 'zbgl/fgsgl/getById',
                listAdvSearchAllFields: 0
            },
            showdia: false
        }
    },
    computed: {
        ...mapGetters(['loginUser', 'routes'])
    },
    watch: {},
    created() {
        document.addEventListener('keydown', this.handleEnterKey)
        this.getAllData()
    },
    beforeDestroy() {
        document.removeEventListener('keydown', this.handleEnterKey)
    },
    mounted() {},
    methods: {
        handleEnterKey(event) {
            if (event.key === 'Enter') {
                this.getAllData()
            }
        },
        getAllData() {
            var _this = this
            const dataParam = new FormData()
            dataParam.append('pageNum', 1)
            dataParam.append('pageSize', 4)
            dataParam.append('searchAndOr', 'or')
            dataParam.append('searchMap[name]', this.filterText)
            dataParam.append('searchMap[creator]', this.filterText)
            this.$http({
                method: 'POST',
                contentType: 'application/x-www-form-urlencoded',
                url: '/zbgl/fgsgl/listdata',
                data: dataParam,
                params: {
                    orderBy: 'establishTime desc'
                }
            }).then((res) => {
                if (res.code === 'success') {
                    this.allDataList = res.body.pageInfo.list
                } else {
                    this.$alert(res.message, '操作提示', { type: 'error' })
                }
            })
        },

        onCellLink(row) {
            this.showdia = false
            if (row.id) {
                var _this = this
                _this.formTitle = '分公司信息'
                _this.busiformBtns = [
                    {
                        id: 'btn_close',
                        btnName: '关 闭',
                        btnIcon: 'close',
                        btnClick: 'closeDialog',
                        btnPermission: '',
                        btnType: ''
                    }
                ]
                this.showdia = true
                _this.moduleInfo.formTemplate = '#/dcontent/vuebusiform/W/zbgl.fgsgl.form.vue?sysCode='
                _this.$options.components['BusiForm'] = _this.$loadComponent(_this.moduleInfo.formTemplate)
                _this.$nextTick(() => {
                    _this.$bus.emit('openBusiform', _this.moduleInfo, row, 0, (res) => {
                        this.showdia = false
                    })
                })
            }
        }
    }
}
</script>

<style scoped lang="scss">
#tzgg-body {
    height: 100%;
    // @import url(); 引入公共css类
    #item-body {
        width: 100%;
        height: 100%;
        padding: 0;
        margin: 0;
        .link-message + .link-message {
            border-top: 1px dashed #ebeef5;
            // border-top:none !important;
        }
        .link-message {
            width: 100%;
            height: 71px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            list-style: none;
            padding: 10px 20px;
            .item {
                // padding: 10px 0;
                width: 100%;
                height: 100%;
            }

            cursor: pointer;
            &:hover {
                // background-color: #F5F7FA;
            }
            &:last-child {
                border-bottom: none;
            }
            .title {
                font-size: 14px;
                color: #333333;
                height: 25px;
                line-height: 25px;
                width: 100%;
                position: relative;
                padding-right: 10px;
                display: inline-block;
                .msg {
                    display: block;
                    width: 60%;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }
                .right {
                    display: block;
                    width: 40%;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    text-align: right;
                    color: #9e9e9e;
                }
                .no-read {
                    display: block;
                    width: 6px;
                    height: 6px;
                    border-radius: 6px;
                    background: red;
                    position: absolute;
                    left: -10px;
                    top: 12px;
                    z-index: 100;
                }
            }
            .bottom {
                font-size: 13px;
                color: #9b9b9b;
                height: 25px;
                line-height: 25px;
                font-family: MicrosoftYaHei;
                .name {
                    display: inline-block;
                    width: 60%;
                    text-align: left !important;
                    font-size: 13px;
                }
                .time {
                    display: block;
                    display: inline-block;
                    font-size: 13px;
                    font-family: MicrosoftYaHei;
                    color: #ec8423;
                    text-align: right;
                    width: 40%;
                }
                .sender {
                    font-size: 12px;
                }
            }
        }
    }
    // .autoStyle{
    //     height: 100px !important;
    //     overflow-y: auto;
    // }
    // .autoStyle::-webkit-scrollbar{
    //     display: none;
    // }
}
</style>
